module.exports = __webpack_public_path__ + "static/media/prv7.4d529cd9.jpg";